import { Modal } from "./AdministrationFields";
import { formatPatientName } from "../model/administrationRules";
import { secondaryButtonStyle } from "../styles/administrationModalStyles";
import { patientDocumentEmptyStyle, patientDocumentPanelStyle } from "../styles/administrationStyles";

export function PatientDocumentPanel({ documents, busy, uploadEnabled, onUpload, onOpen, onDelete }) {
    return (
        <div style={patientDocumentPanelStyle}>
            {uploadEnabled && (
                <label style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "fit-content",
                    minHeight: "34px",
                    padding: "7px 12px",
                    borderRadius: "6px",
                    border: "1px solid #0f766e",
                    background: busy ? "#99f6e4" : "#0f766e",
                    color: "white",
                    cursor: busy ? "default" : "pointer",
                    fontSize: "13px",
                    fontWeight: 700,
                }}>
                    {busy ? "Import..." : "Ajouter une pièce jointe"}
                    <input
                        type="file"
                        accept="application/pdf,image/*,.pdf,.jpg,.jpeg,.png,.webp"
                        disabled={busy}
                        onChange={event => {
                            const file = event.target.files?.[0];
                            event.target.value = "";
                            if (file) onUpload(file);
                        }}
                        style={{ display: "none" }}
                    />
                </label>
            )}
            {documents.length === 0 ? (
                <div style={patientDocumentEmptyStyle}>
                    {uploadEnabled ? "Aucune pièce jointe ajoutée." : "Cochez l'autorisation pour ajouter une pièce jointe."}
                </div>
            ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    {documents.map(document => (
                        <div key={document.id} style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                            padding: "9px 10px",
                            border: "1px solid #ccfbf1",
                            borderRadius: "8px",
                            background: "#f0fdfa",
                        }}>
                            <button
                                type="button"
                                onClick={() => onOpen(document)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    color: "#0f766e",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    fontSize: "13px",
                                    textAlign: "left",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {document.fileName || "Document"}
                            </button>
                            <button
                                type="button"
                                disabled={busy}
                                onClick={() => onDelete(document)}
                                style={{ ...secondaryButtonStyle, padding: "6px 9px", flexShrink: 0 }}
                            >
                                Supprimer
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export function PatientDocumentsModal({ row, busy, onClose, onUpload, onOpen, onDelete }) {
    return (
        <Modal title={`Documents — ${formatPatientName(row)}`} onClose={onClose} width={620}>
            <PatientDocumentPanel
                documents={row.documents || []}
                busy={busy}
                uploadEnabled
                onUpload={onUpload}
                onOpen={onOpen}
                onDelete={onDelete}
            />
        </Modal>
    );
}
